import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import type { ScrollableContainerTypes } from '@wix/editor-elements-preview-utils';
import { withScrollAPIForResponsiveContainer } from '@wix/editor-elements-preview-utils';
import type { IComponentPreviewWrapper } from '@wix/editor-elements-types/thunderboltPreview';
import React from 'react';
import type {
  IResponsivePopupContainerPreviewProps,
  IResponsivePopupContainerProps,
} from '../ResponsivePopupContainer.types';

const noop = () => {};

function withComponentPreview(
  ViewerComponent: React.ComponentType<IResponsivePopupContainerProps>,
): IComponentPreviewWrapper<
  IResponsivePopupContainerProps,
  IResponsivePopupContainerPreviewProps
> {
  return React.forwardRef((props, ref) => {
    const {
      previewWrapperProps = {},
      setSiteScrollingBlocked,
      ...viewerProps
    } = props;
    const { componentViewMode } = previewWrapperProps;

    const isEditorMode = componentViewMode === 'editor';

    return (
      <ViewerComponent
        {...viewerProps}
        setSiteScrollingBlocked={isEditorMode ? noop : setSiteScrollingBlocked}
        ref={ref}
      />
    );
  });
}

export default (
  ViewerComponent: React.ComponentType<ScrollableContainerTypes>,
) => {
  return createComponentPreviewEntry(
    withComponentPreview(
      withScrollAPIForResponsiveContainer(
        ViewerComponent,
      ) as React.ComponentType<IResponsivePopupContainerProps>,
    ),
  );
};
